import { useContext } from "react"
import { Route, Routes } from "react-router-dom";
import { Login } from "../Components/login";
import { Users } from "../Components/users";
import { GlobalContext } from "../Context/globalContext"

export const Routing = () => {

    const globalContext = useContext(GlobalContext);

    return (
        <>
            {globalContext.loggedIn ?
                <Routes>
                    <Route path="*" element={<Users />} />
                </Routes>
                :
                <Routes>
                    <Route path="*" element={<Login />} />
                </Routes>
            }
        </>
    )

}